import React, {useState} from 'react'
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { MdMilitaryTech } from "react-icons/md";
import { BiMessageSquareDetail } from "react-icons/bi";
import { AiOutlineProject } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";
import { GiArchiveResearch } from "react-icons/gi";

import "./styles.css"

const Navbar = () => {

    const [activeNav, setActiveNav] = useState('#')

  return (
    <nav>
        <a href="#" onClick={()=> setActiveNav('#')} className={activeNav === '#'?'active':''}><AiOutlineHome/></a>
        <a href="#about" onClick={()=> setActiveNav('#about')} className={activeNav === '#about'?'active':''}><AiOutlineUser/></a>
        <a href="#experience" onClick={()=> setActiveNav('#experience')} className={activeNav === '#experience'?'active':''}><VscFolderLibrary/></a>
        <a href="#skills" onClick={()=> setActiveNav('#skills')} className={activeNav === '#skills'?'active':''}><MdMilitaryTech/></a>
        <a href="#projects" onClick={()=> setActiveNav('#projects')} className={activeNav === '#projects'?'active':''}><AiOutlineProject/></a>
        <a href="#publications" onClick={()=> setActiveNav('#publications')} className={activeNav === '#publications'?'active':''}><GiArchiveResearch/></a>
        <a href="#contact" onClick={()=> setActiveNav('#contact')} className={activeNav === '#contact'?'active':''}><BiMessageSquareDetail/></a>
    </nav>
  )
}

export default Navbar